export enum SmsNotificationDataHooks {
  main = 'sms-notification',
  text = 'sms-notification-text',
}
